<template>
  <div class="">
    <h2>掲載されている複数のイベントにお申込をされる方へ</h2>

    <p>
      こちらから申請を行って頂きますと、イベント管理システム「イベントクリエイト」で作成されたイベントの申込に利用できるメールアドレスを発行致します。
    </p>

    <p>
      申請されますと、申請件数分の
      <code>*********@fwd.evecre.com</code>
      というメールアドレスが発行されます。<br>
      発行されたメールアドレス宛に送られたメールは、「あなたのメールアドレス」宛に自動的に転送されます。
    </p>

    <p>
      発行されたメールアドレスを使い、参加申込を行ってください。
    </p>

    <h3>利用制限</h3>

    <p>ご利用にあたって下記の利用制限がございます。予めご了承下さい。</p>

    <ul>
      <li>発行されたメールアドレスの利用期限は、発行から6ヶ月です。期限を過ぎたメールアドレスに送信されるメールは転送されません</li>
      <li>宛先数（To、Cc、Bccの合計）が50を超えるメールは転送されません</li>
      <li>10MBバイト（ヘッダー・本文を含める）を超えるメールは転送されません</li>
      <li>発行されたメールアドレスは、イベントクリエイトで作成されたイベントへの申し込み用途外には利用されないようご注意ください</li>
    </ul>

    <hr>

    <form v-on:submit.prevent="doRegister()">
      <div class="form-group" v-bind:class="{ 'has-danger': errors.originalAddress.length > 0 }">
        <label>転送先のメールアドレス</label>
        <input v-model="originalAddress" type="email" class="form-control" placeholder="your-name@example.jp" required>
        <p class="form-control-feedback" v-for="e in errors.originalAddress">
          <span v-if="e === 'Should not be empty.'">入力してください。</span>
          <span v-else-if="e === 'Should be an email.' || e === 'This domain has no MX record.'">正しいメールアドレスではありません。入力に誤りが無いかご確認下さい。</span>
          <span v-else-if="e === 'This domain is not allowed.'">転送メールアドレス自信を登録する事はできません。</span>
          <span v-else>{{ e }}</span>
        </p>
        <p class="form-text text-muted">※こちらにはあなたのメールアドレスを入力してください。</p>
      </div>
      <div class="form-group" v-bind:class="{ 'has-danger': errors.desiredCount.length > 0 }">
        <label>発行するメールアドレスは何件必要ですか？</label>
        <select v-model="desiredCount" class="form-control">
          <option>1</option>
          <option>2</option>
          <option>3</option>
          <option>4</option>
          <option>5</option>
        </select>
        <p class="form-control-feedback" v-for="e in errors.desiredCount">
          <span>{{ e }}</span>
        </p>
      </div>
      <button type="submit" class="btn btn-primary" disabled v-if="sending">お待ち下さい...</button>
      <button type="submit" class="btn btn-primary" v-else>発行する</button>
    </form>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data: () => ({
      originalAddress: '',
      desiredCount: 1,
      sending: false,
      errors: {
        originalAddress: [],
        desiredCount: []
      }
    }),
    methods: {
      doRegister () {
        this.sending = true

        // https://netsket.esa.io/posts/163
        axios.post(process.env.API_ENDPOINT_PREFIX + '/addresses', {
          original_address: this.originalAddress,
          desired_count: parseInt(this.desiredCount)
        })
          .then(response => {
            console.log(response)

            if (response.status === 204) {
              alert('既に5個の有効なメールアドレスが存在する為作成できませんでした。')
            } else if (response.status === 201) {
              sessionStorage.setItem('registeredAddresses', JSON.stringify(response.data))
              this.$router.push({ name: 'complete' })
            }
          })
          .catch(e => {
            console.log(e, e.response)

            if (e.response.status === 422 && e.response.data.errors) {
              const processedErrors = {}
              e.response.data.errors.forEach(error => {
                const camelCasedName = error.field.replace(/_([a-z])/g, g => g[1].toUpperCase())

                if (!processedErrors[camelCasedName]) {
                  processedErrors[camelCasedName] = []
                }
                processedErrors[camelCasedName].push(error.code === 'custom' ? error.message : 'Something went wrong')
              })

              this.errors = Object.assign(this.errors, processedErrors)
            } else {
              alert('サーバー内でエラーが発生した為、登録ができませんでした。後程再度お試し下さい。')
            }
          })
          .then(() => {
            this.sending = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Form.vue?74c2995a